import { render } from "./ChannelsInput.vue?vue&type=template&id=52b2beca&ts=true"
import script from "./ChannelsInput.vue?vue&type=script&lang=ts"
export * from "./ChannelsInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__